// assets/logo-spinner.js.liquid
document.addEventListener('DOMContentLoaded', function() {
  const logoImage = document.querySelector('.header-logo__image');
  
  // Find all clickable menu items (adjust selectors if needed)
  const menuItems = document.querySelectorAll(
    '.header__menu-item > a, ' +
    '.header__menu-dropdown a, ' +
    '[ref="submenu"] a, ' +
    '.header-menu a'
  );
  
  if (logoImage && menuItems.length > 0) {
    menuItems.forEach(menuItem => {
      menuItem.addEventListener('click', function() {
        // Remove and re-add class to restart animation
        logoImage.classList.remove('spinning');
        void logoImage.offsetWidth; // Force reflow
        logoImage.classList.add('spinning');
        
        // Remove class after animation completes
        setTimeout(() => {
          logoImage.classList.remove('spinning');
        }, 1000);
      });
    });
  }
});